import React, {useEffect, useState} from 'react'
import { ReactInternetSpeedMeter } from 'react-internet-meter'

const Speed = () => {

    const [speed, setSpeed] = useState("0.0");
    const [color, setColor] = useState("#0f18d6");
    return (
        <>
            <divc className={"d-flex"} style={{color:'black'}}>
                <ReactInternetSpeedMeter
                    txtSubHeading={"Internet speed is 🌐"}
                    outputType="alert"
                    customClassName={null}
                    txtMainHeading=""
                    pingInterval={30000} // milliseconds
                    thresholdUnit='megabyte' // "byte" , "kilobyte", "megabyte"
                    threshold={100}
                    imageUrl="https://images.pexels.com/photos/3396664/pexels-photo-3396664.jpeg?cs=srgb&dl=pexels-josiah-farrow-3396664.jpg&fm=jpg"
                    downloadSize="1781287"  //bytes
                    callbackFunctionOnNetworkDown={(speed)=>console.log(`Internet speed is down ${speed}`)}
                    callbackFunctionOnNetworkTest={(speed)=>setSpeed(speed)}
                />
                <div style={{color:color, marginLeft:'3px'}}>
                    {speed} mb/s
                </div>
            </divc>
        </>
    )

}

export default Speed